// import pages from './pages';
import utilities from './utilities';
// import other from './other';
import pastetext from './pastetext';
import trustedPartners from './trustedPartners';
// ==============================|| MENU ITEMS ||============================== //
//items: [dashboard, pages, utilities, other]
const menuItems = {
  items: [ pastetext, utilities, trustedPartners]
};

export default menuItems;
